<script>
    /*
    	ConnectButton.svelte
    */

    import { onMount } from 'svelte';

    // TCARE components

    // SMUI components

    export let submitReferral;

    onMount(() => {
    })

</script>

<style>

    /* TODO: use a SMUI Button here? */
    .connect-button button {
        width: 125px;
        height: 35px;
        margin: 0px;
        font-size: 14px;
        line-height: 16px;
        letter-spacing: 1px;
        color: white;
        background-color: var(--tcui-secondary);
        border-radius: 16px;
        border: none;
    }

    .connect-button button:hover {
        background-color: var(--tcui-aqua);
    }

    @media screen and (max-width: 600px) {
    }

    @media screen and (min-width: 601px) and (max-width: 1300px) {
    }

    @media screen and (min-width: 1201px) {
    }

</style>

<div class="connect-button">
    <button on:click={submitReferral}>
        Save Resource
    </button>
</div>
